export var ENCRYPTED_ENTRY_ERROR_MESSAGE = 'encrypted entries not supported';
export var NO_NAME_OR_SRC_ERROR_MESSAGE = 'no name or src for entry';